module.exports = __webpack_public_path__ + "img/62.165ebbe2.jpg";